import ReactSelect from 'react-select';
import styled from 'styled-components';

import colors from 'styles/colors';

const SelectContainer = styled.div`
  position: relative;
`;

const StyledReactSelect = styled(ReactSelect)`
  font-weight: 600;

  & .Select__dropdown-indicator {
    padding: 4px;
  }

  ${(props) =>
    props.readOnly &&
    `
    & .Select__dropdown-indicator {
      visibility: hidden;
    }
  `}

  & .Select__control {
    min-height: 30px;
    border-color: ${({ errored }) => (errored ? colors.red : colors.fleetOffGray)};
    border-radius: 3px;
    box-shadow: unset;
  }

  .Select__control--menu-is-open,
  .Select__control--is-focused {
    border-color: ${colors.blue};

    &:hover {
      border-color: ${colors.blue};
    }
  }

  & .Select__value-container {
    padding: 0 8px;
  }

  & .Select__control--is-disabled {
    background-color: ${colors.fleetOffGray};
  }

  & .Select__single-value--is-disabled {
    color: ${colors.black};
  }

  & .Select__option--is-selected {
    background-color: ${colors.fleetBlue};
  }

  & .Select__input > input {
    font-weight: 600;
  }

  & .Select__menu {
    border-color: ${colors.fleetOffGray};
    border-radius: 3px;
  }
`;

export const Select = (props) => {
  const { disabled = false } = props;

  const components = {
    IndicatorSeparator: () => null,
    ...props.components,
  };

  const styles = {
    ...props.styles,
  };

  return (
    <SelectContainer>
      <StyledReactSelect
        {...props}
        classNamePrefix={'Select'}
        styles={styles}
        isDisabled={disabled || props.readOnly}
        components={components}
      />
    </SelectContainer>
  );
};

export default Select;
